import { render } from "./IsLoading.vue?vue&type=template&id=6cb8b8f0"
import script from "./IsLoading.vue?vue&type=script&lang=js"
export * from "./IsLoading.vue?vue&type=script&lang=js"

import "./IsLoading.vue?vue&type=style&index=0&id=6cb8b8f0&lang=scss"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__